<template>
  <div v-if="display" class="text-center">
    <div class="d-inline-block">
      <b-spinner class="align-middle" variant="secondary"></b-spinner>
      <strong class="ml-2 text-secondary align-middle">{{ text }}</strong>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpinnerDiv',
  props: {
    display: {
      type: Boolean,
      default: true,
    },
    text: {
      type: String,
      default: 'loading content...',
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped></style>
